(function() {
    'use strict';

    angular
        .module('moldovaYieldCurvesApp')
        .controller('QuotingDialogController', QuotingDialogController);

    QuotingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Quoting'];

    function QuotingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Quoting) {
        var vm = this;

        vm.quoting = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.quoting.id !== null) {
                Quoting.update(vm.quoting, onSaveSuccess, onSaveError);
            } else {
                Quoting.save(vm.quoting, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('moldovaYieldCurvesApp:quotingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
